export function initKva() {
  if (!document.getElementById("kva-script")) {
    const script = document.createElement("script");
    script.setAttribute("id", "kva-script");
    script.type = "text/javascript";
    script.src =
      (process.env.REACT_APP_KVA_URL ||
        "https://kv-analytics-dc2d.citigo.net") + "/analytic.js";
    document.getElementsByTagName("head")[0].appendChild(script);
  }
  const websiteWindow: any = window;
  if (!websiteWindow.kva) {
    websiteWindow.kva = function (...args: any) {
      (websiteWindow.kva.q = websiteWindow.kva.q || []).push(args);
    };
  }
}

export async function sendKvaEvent(
  platform: string,
  merchantId: string,
  eventAction: string,
  eventLabel?: string,
  eventValue?: string,
  fieldsObject?: { [key: string]: any }
) {
  const websiteWindow: any = window;
  await initKva();
  websiteWindow.kva.l = +new Date();
  websiteWindow.kva("create", merchantId, "auto", "mykiot_tracker");
  websiteWindow.kva(
    "mykiot_tracker.send",
    "event",
    platform,
    eventAction,
    eventLabel,
    eventValue,
    fieldsObject
  );
}
